import { useStorage } from "app/custom-hooks/storage/useStorage";
import AdIntelligenceUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/AdIntelligenceUpgradeBanner";
import { leadsSearchSessionStorage } from "app/pages/sales-intelligence/modules/leads-search/services/storage";

export const DisplayAdsFormatUpgradeView = () => {
    const [isSubmitted, setSubmitted] = useStorage<boolean>(
        leadsSearchSessionStorage.displayAdsFormatFilterHookSubmitted,
    );

    return (
        <AdIntelligenceUpgradeBanner
            isSubmitted={isSubmitted}
            variant="display_ads_format_filter"
            onSubmit={() => setSubmitted(true)}
        />
    );
};
